import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntroductionVideoComponent } from './introduction-video.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { createTranslateLoader } from '../../http-loader-factory';
import { CustomPipeModule } from '../../pipes/custom-pipe.module';

@NgModule({
  imports: [
    CommonModule,
    MatDialogModule,
    CustomPipeModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  declarations: [IntroductionVideoComponent],
  exports: [IntroductionVideoComponent],
})
export class IntroductionVideoModule {}
